import { reduxForm } from 'redux-form'
import moment from 'moment'
import at from 'lodash/at'
import { goBack } from 'react-router-redux'

import { createQAWorkOrder } from '../../actions/qa-work-orders'

import QAWorkOrderForm from '../../components/qa-work-orders/qa-work-order-form'

const fields = [
  'contact',
  'locationId',
  'timezone'
]

function mapStateToProps (state, ownProps) {
  const locations = at(state.locations, state.pagination.locations.ids || [])

  return {
    modalTitle: 'Add a QA Work Order',
    initialValues: {
      timezone: moment.tz.guess()
    },
    locations
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit (data) {
      dispatch(createQAWorkOrder(data))
        .then(() => dispatch(goBack()))
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'createQAWorkOrder'
  },
  mapStateToProps,
  mapDispatchToProps
)(QAWorkOrderForm)



// WEBPACK FOOTER //
// ./src/containers/qa-work-orders/qa-work-order-create-container.js